/**
 * Пункты модуля секций: роутинг /sections/:view?
 * IA сайдбара: docs/product/2026-08-16-admin-domain-ia.md
 */

export const SECTION_NAV_VIEWS = [
  { key: 'list', label: 'Секции' },
  { key: 'schedule', label: 'Расписание' },
  { key: 'requests', label: 'Заявки' },
  { key: 'clients', label: 'Клиенты' },
  { key: 'abonements', label: 'Абонементы' },
  { key: 'personal', label: 'Персональные' },
];

/**
 * Третий уровень под пунктом «Секции» в сайдбаре.
 * Список секций — сам родительский пункт (key: list).
 */
export const SECTION_NESTED_SIDEBAR_VIEWS = [
  { key: 'schedule', label: 'Расписание' },
  { key: 'abonements', label: 'Абонементы' },
  { key: 'requests', label: 'Заявки' },
  { key: 'personal', label: 'Персональные' },
];

/** @deprecated aliases for older imports */
export const SECTION_L2_SIDEBAR_VIEWS = [
  { key: 'list', label: 'Секции' },
  { key: 'requests', label: 'Заявки' },
];

export const SECTION_L3_SERVICE_VIEWS = [
  { key: 'abonements', label: 'Абонементы' },
  { key: 'personal', label: 'Персональные' },
];

export const SECTION_SIDEBAR_VIEWS = [
  { key: 'list', label: 'Секции' },
  ...SECTION_NESTED_SIDEBAR_VIEWS,
];

export function isClientsPath(pathname) {
  const p = pathname || '';
  return p === '/sections/clients' || p.startsWith('/sections/clients/');
}

export function isSectionsPath(pathname) {
  const p = pathname || '';
  return p === '/sections' || p.startsWith('/sections/') || p.includes('/sections/');
}

/** Ветка «Секции» в сайдбаре: клиенты — отдельный пункт организации. */
export function isSectionsSidebarPath(pathname) {
  return isSectionsPath(pathname) && !isClientsPath(pathname);
}

export function getSectionViewFromPathname(pathname) {
  const p = pathname || '';
  const match = p.match(/^\/sections(?:\/([^/?#]+))?/);
  if (!match) return null;
  const key = match[1];
  if (!key || key === 'list') return 'list';
  return SECTION_NAV_VIEWS.some((view) => view.key === key) ? key : 'list';
}

/**
 * Собирает путь вкладки секций, сохраняя centerId/sectionId из текущего search.
 */
export function buildSectionsNavPath(viewKey, search) {
  const params = new URLSearchParams(search || '');
  const next = new URLSearchParams();
  const centerId = params.get('centerId');
  const sectionId = params.get('sectionId');
  if (centerId) next.set('centerId', centerId);
  if (sectionId) next.set('sectionId', sectionId);
  const viewPart = !viewKey || viewKey === 'list' ? '' : `/${viewKey}`;
  const qs = next.toString();
  return `/sections${viewPart}${qs ? `?${qs}` : ''}`;
}
